import { routes } from '@routes';

import { usePageContext } from '../../../../../../providers/PageProvider';
import { InfoBlock } from '../../styles/InfoBlock';
import { InfoBlockContent } from '../../styles/InfoBlockContent';
import { InfoBlockTitle } from '../../styles/InfoBlockTitle';
import { InfoBlockWrapper } from '../../styles/InfoBlockWrapper';
import { JobSection } from '../../styles/JobSection';
import { JobSectionLeft } from '../../styles/JobSectionLeft';
import { JobSectionRight } from '../../styles/JobSectionRight';
import { StyledLink } from '../../styles/StyledLink';

export const EnhancementSection = () => {
  const { job, metadata } = usePageContext();

  if (!job || !metadata) {
    return null;
  }

  return (
    <JobSection>
      <JobSectionLeft>Enhancements</JobSectionLeft>
      <JobSectionRight>
        <InfoBlockWrapper>
          <InfoBlock>
            <InfoBlockTitle>Proceeding Type</InfoBlockTitle>
            <InfoBlockContent className="align-middle flex gap-2">{metadata.proceeding_type}</InfoBlockContent>
          </InfoBlock>
          <InfoBlock>
            <InfoBlockTitle>Inferred Speaker Count</InfoBlockTitle>
            <InfoBlockContent>
              {metadata?.speakers.length ? (
                <StyledLink to={routes.adminJobTranscriptPlayer.make(job?.id)}>
                  Speaker count: {metadata?.speakers.length}
                </StyledLink>
              ) : (
                '---'
              )}
            </InfoBlockContent>
          </InfoBlock>
        </InfoBlockWrapper>

        <InfoBlockWrapper>
          {metadata?.speakers?.map((speaker, idx) => (
            <InfoBlock key={idx}>
              <InfoBlockTitle>{speaker.post_asr_label}</InfoBlockTitle>
              <InfoBlockContent>
                <div className="text-xs mb-4">
                  <p>
                    <small>First name:</small> {speaker.first_name}
                  </p>
                  <p>
                    <small>Last name:</small> {speaker.last_name}
                  </p>
                  <p>
                    <small>Role:</small> {speaker.role}
                  </p>
                  <p>
                    <small>Prefix:</small> {speaker.honorific_prefix}
                  </p>
                  <p>
                    <small>ASOne label:</small> {speaker.real_time_asr_label}
                  </p>
                </div>
              </InfoBlockContent>
            </InfoBlock>
          ))}
        </InfoBlockWrapper>

        <div className="w-3/4 mt-4">
          <InfoBlockTitle>Summary</InfoBlockTitle>
          <InfoBlockContent>
            <div className="text-sm mb-4">{metadata.summary}</div>
          </InfoBlockContent>
        </div>
      </JobSectionRight>
    </JobSection>
  );
};
